// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"FeedbackMenu_iconWrapper__lKU9T","active":"FeedbackMenu_active__2Bpe8","button":"FeedbackMenu_button__2_AIt"};